import { Checkmark } from '@c/icons/checkmark';

interface WishlistActionProps {
  removed: boolean;
}
const WishlistAction = ({ removed }: WishlistActionProps) => {
  return (
    <div className="flex w-full select-none items-center justify-evenly gap-[1.2rem]">
      <div className="flex items-center rounded-full bg-brand-primary p-[0.5rem]">
        <Checkmark variant="white" height={18} width={18} />
      </div>
      <p className="whitespace-nowrap font-semibold text-brand-black">
        {removed ? 'Item removed from wishlist' : 'Item added to wishlist'}
      </p>
    </div>
  );
};

export default WishlistAction;
